"use client";
import React from "react";

import { useFeatureFlag } from "@stadium/services/launch-darkly/use-feature-flag";

type withSyncFeatureFlagOptions = {
  loader?: React.ReactNode;
};

export const withSyncFeatureFlag = <T,>(
  Component: React.ComponentType<T>,
  { loader = null }: withSyncFeatureFlagOptions = {} as withSyncFeatureFlagOptions,
): React.ComponentType<T> => {
  const WrappedComponent = (props: T) => {
    const { isReady } = useFeatureFlag();
    if (!isReady) return loader;

    return <Component {...props} />;
  };
  return WrappedComponent as React.ComponentType<T>;
};
